var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('h2',{staticStyle:{"color":"#c5a660","margin":"5rem auto"}},[_vm._v("404, 您的页面走丢了")])])
}]

export { render, staticRenderFns }